import ApplicationSerializer from 'eflex/serializers/application';

export default class PushToScheduleConfigSerializer extends ApplicationSerializer {
  attrs = {
    taskConfig: {
      serialize: false,
      deserialize: false,
    },
  };
}
